import { render, staticRenderFns } from "./ServiceTerritory.vue?vue&type=template&id=52477999&scoped=true&"
import script from "./ServiceTerritory.vue?vue&type=script&lang=js&"
export * from "./ServiceTerritory.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTerritory.vue?vue&type=style&index=0&id=52477999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52477999",
  null
  
)

export default component.exports